import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { deviceType } from 'detect-it';


import { $Elements, Animations, Classes, Elements, Events } from './constants';
import { fixMobileHover, formDataToJson, getCookiesAllowed, initGTM, initLightboxes, isDisclaimerAccepted, loadExternalScript, resetCookiesAllowed, resetGTMConsent, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, sortAnimations, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Touch Screen ----------

if(deviceType === 'touchOnly') {
	$Elements.html.addClass('touchscreen');
}

// ---------- Fix VH ----------

$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
$Elements.window.trigger('resize');

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	loadExternalScript(
		'<script src="https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs" type="module"></script>'
	)

	// ---------- Fix Mobile Hover ----------

	fixMobileHover();

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.PageWrapper.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.PageWrapper.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target[0]);
		}
	});

	$Elements.PageWrapper.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	initLightboxes();

	// ---------- Cookies ----------

	initGTM();

	const initCookiesAllowed = async() => {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});

			$(cookies).on('closed.bs.alert', function() {
				cookies.classList.add(Classes.hidden);
				document.body.append(cookies);
			});
		}
	};

	if(!getCookiesAllowed()) {
		await initCookiesAllowed();
	}

	$('[data-reset-cookies-allowed]').click(async function() {
		resetCookiesAllowed();
		resetGTMConsent();
		await initCookiesAllowed();
	});

});

// ---------- Disclaimer ----------

if(!isDisclaimerAccepted()) {

	if(!document.body.classList.contains('page-template-default')) {

		$('form.disclaimer-form').each(function() {

			const disclaimer = document.querySelector('#disclaimer');
			disclaimer.classList.remove(Classes.hidden);
			$Elements.body.addClass(Classes.disclaimer);

			const form = $(this);
			const button = form.find('button[type=submit]');

			document.querySelectorAll('.max-number').forEach(input => {
				input.addEventListener('input', e => {
					let val = e.target.value,
						len = +e.target.getAttribute('maxlength');
					e.target.value = val.slice(0, len);
				})
			})

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				const data = formDataToJson(new FormData(this));
				const currentYear = new Date().getFullYear();
				const birthyear = form.find('input[name="birthyear"]');

				button.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				if(!parseInt(data?.birthyear)) {
					birthyear.addClass(Classes.isInvalid);
					return;
				}
				else {
					birthyear.removeClass(Classes.isInvalid);
				}

				if(parseInt(data?.birthyear) <= (currentYear - 18)) {
					$(disclaimer).alert('close');
				}
				else {
					form.find('.alert').addClass(Classes.show);
				}

				button.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);
			});

			$(disclaimer).on('close.bs.alert', function() {
				setDisclaimerAccepted();
				$Elements.body.removeClass(Classes.disclaimer);
			});
		});
	}
}

